<template>
  <div class="container">
    <div class="main-container">
      <div class="left-box">
        <div class="panel address-panel">
          <h2 class="title">
            <span>Confirm Shipping Address</span>
            <span class="btn-address" @click="add_address">Use New Address</span>
          </h2>
          <div class="address-list">
            <div
              class="address-item"
              :class="{ active: form_data.address_id === v.id }"
              v-for="(v, k) in address_list"
              :key="`a` + k"
              @click="change_address(v)"
            >
              <img
                v-if="form_data.address_id === v.id"
                src="../../assets/images/icon-location-active.png"
                class="location"
                alt=""
              />
              <img
                v-else
                src="../../assets/images/icon-location.png"
                class="location"
                alt=""
              />
              <div class="flex align-center justify-between">
                <div class="address-content">
                  <div class="content1">
                    {{ v.title }} {{ v.first_name }}{{ v.last_name }}
                  </div>
                  <div class="content2">
                    {{ v.address }} {{ v.address_alternate }},{{v.city}},{{ v.state }},{{ v.zip_code }}
                  </div>
                  <div>{{ v.country }}</div>
                </div>
                <div class="text-black margin-right-20">
                  <div class="">Phone number</div>
                  <div class="margin-top-10">{{ v.phone }}</div>
                </div>
              </div>
              <div class="btn-edit" @click.stop="edit_address(v.id)">Edit</div>
            </div>
          </div>
        </div>

        <popup
          :show.sync="is_popup_show"
          width="560px"
      height="850px"
      class="bg-white"
          @on-close="close"
        >

          <h2>{{ form_data_address.id ? "Edit Shipping Address" : "Add Shipping Address" }}</h2>
          <Form
        class="address-form"
        ref="formValidate"
        :model="form_data_address"
        :rules="rules"
      >
        <div class="form-group">
          <FormItem prop="country" label="Country/region">
            <Select
              v-model="form_data_address.country"
              filterable
              style="height: 40px"
            >
              <Option
                :value="item.name"
                :key="index"
                v-for="(item, index) in countryList"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <div class="form-group">
          <FormItem prop="title" label="Title (optional)" style="width: 245px">
            <Select v-model="form_data_address.title" style="height: 40px">
              <Option value="Mr">Mr</Option>
              <Option value="Mrs">Mrs</Option>
              <Option value="Mrs">Miss</Option>
              <Option value="Ms">Ms</Option>
              <Option value="Ms">Sir</Option>
            </Select>
          </FormItem>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="first_name" label="First name">
              <Input
                type="text"
                class="input"
                v-model="form_data_address.first_name"
                style="width: 245px"
              />
            </FormItem>
            <FormItem prop="last_name" label="Last name">
              <Input
                type="text"
                class="input"
                v-model="form_data_address.last_name"
                style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <FormItem prop="address" label="Address line one">
            <Input
              type="text"
              class="input"
              v-model="form_data_address.address"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem
            prop="address_alternate"
            label="Address line two (optional)"
          >
            <Input
              type="text"
              class="input"
              v-model="form_data_address.address_alternate"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem prop="city" label="City">
            <Input type="text" class="input" v-model="form_data_address.city" />
          </FormItem>
        </div>

        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="state" label="State" style="width: 245px">
              <Select v-model="form_data_address.state" style="height: 40px">
                <Option
                  :value="item.name"
                  :key="index"
                  v-for="(item, index) in stateList"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>

            <FormItem prop="zip_code" label="ZIP code" style="width: 245px">
              <Input
                type="text"
                class="input"
                v-model="form_data_address.zip_code"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="phone" label="Phone number">
              <Input
                type="text"
                class="input"
                v-model="form_data_address.phone"
                style="width: 245px"
              />
            </FormItem>
            <FormItem
              prop="phone_alternate"
              label="Alternate number (optional)"
            >
              <Input
                type="text"
                class="input"
                v-model="form_data_address.phone_alternate"
                style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="flex align-center justify-center">
          <Button class="btn-submit" @click="save('formValidate')"
            >Save</Button
          >
        </div>
      </Form>
        </popup>

        <div class="panel product-panel">
          <table border>
            <thead>
              <tr>
                <th>Product Information</th>
                <th>Size</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(v,k) in detail.mtms">
                <tr>
                  <td>
                    <div class="info">
                      <img :src="v.design_data.category.image" alt="" class="image" />
                      <div class="name">{{ v.design_data.category.style_no }}</div>
                      <div class="category">{{ v.design_data.category.product_category_name }}</div>
                    </div>
                  </td>
                  <td>
                    {{v.spec_info.join('；')}}
                  </td>
                  <td>×{{ v.quantity }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="panel summary-panel">
          <div class="wrap">
            <div class="left">
              <div class="item">
                <div class="label" style="font-size: 15px">Order Details</div>
                <div class="text"></div>
              </div>
              <div class="item">
                <div class="label">Order No.:</div>
                <div class="text">{{ detail.order_no }}</div>
              </div>
              <div class="item">
                <div class="label">Order Date:</div>
                <div class="text">{{ detail.create_time }}</div>
              </div>
              <!-- <div class="item">
                <div class="label">Required Delivery Date:</div>
                <div class="text">
                  <input type="date" v-model="form_data.date_required" />
                </div>
              </div> -->
            </div>
            <div class="right">
              <h2 class="title">Order Remarks</h2>
              <textarea
                cols="30"
                rows="10"
                v-model="form_data.comment"
                placeholder="Please enter remarks"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="panel operation-panel">
          <h2 class="title">Sample Customization Quotation</h2>
          <div class="item" v-for="(vv, kk) in detail.cost">
            <div class="label">{{vv.title}}</div>
            <div class="text">${{ vv.amount }}</div>
          </div>

          <div class="separator"></div>
          <div class="item">
            <div class="label">Total Payment</div>
            <div class="text" style="font-size: 18px; color: #fa3d5a">
              ${{ detail.total_price }}
            </div>
          </div>

          <div class="pay-list">
            <div class="pay-item" v-for="(v, k) in pay_list" :key="`pa` + k">
              <input
                type="checkbox"
                :checked="pay_type == v.type"
                @change="change_payment(v.type)"
              />
              <img :src="v.icon" alt="" class="icon" />
              <span>{{ v.name }}</span>
            </div>

          </div>


          <div class="btn-checkout" @click="checkout">Confirm Payment</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import axios from "axios";
import region from "@/utils/region.js";
import { mapState } from "vuex";
import {
  Profile,
  OrderDetail,
  CheckoutOrder,
  AddressList,
  SaveAddress,
  GetAddress,
  GetRegionList,
} from "@/api/index.js";
const form_data_address = {
  id: 0,
  country: "",
  title: "",
  first_name: "",
  last_name: "",
  state: "",
  address: "",
  address_alternate: "",
  city: "",
  zip_code: "",
  phone: "",
  phone_alternate: "",
  is_default: 0,
};
export default {
  name: "OrderCheckout",
  components: {
    Popup,
  },
  data() {
    return {
      value: [],
      region: region,
      form_data_address: { ...form_data_address },
      is_popup_show: false,
      is_click: false,
      address_list: [],
      form_data: {
        address_id: 0,
        uuid: "",
        date_required: "",
        comment: "",
      },
      pay_type: "paypal",
      detail: {
        spec_info: [],
        cost: [],
      },
      design: {},
      pay_list: [
        {
          name: "PayPal",
          icon: require("../../assets/images/icon_paypal.png"),
          type: "paypal",
        },
          {
          name: "Credit Pay",
          icon: require("../../assets/images/icon_credit.png"),
          type: "credit",
        },

      ],
      countryList: [],
      stateList: [],
      rules: {
        country: [
          {
            required: true,
            message: "Country/region is required",
            trigger: "change",
          },
        ],
        first_name: [
          {
            required: true,
            message: "First name is required",
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: "Last name is required",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "Address line one is required",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "City is required",
            trigger: "blur",
          },
        ],
        zip_code: [
          {
            required: true,
            message: "ZIP code is required",
            trigger: "blur",
          },
        ],
        state: [
          {
            required: true,
            message: "State is required",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "Phone number is required",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
    }),
  },
  watch: {
    "form_data_address.country": function(e) {
      this.getStateList();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      console.log("aaa");
      vm.$emit("showFooter", false);
    });
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
  async mounted() {
    await this.$store.dispatch("getSetting");
    // if (this.setting.offlinePay) {
    //   this.pay_list.push({
    //     name: "Offline Payment",
    //     icon: require("../../assets/images/icon-pay-offline.png"),
    //     type: "offline",
    //   });
    // }
    this.form_data.uuid = this.$route.query.uuid;
    if (this.$route.query.uuid) {
      OrderDetail({
        uuid: this.$route.query.uuid,
      }).then((response) => {
        this.detail = response.data;
        this.design = this.detail.design;
      });
    }
    axios.all([this.getProfile(), this.getAddressList()]).then(
      axios.spread(() => {
        let default_address = this.address_list.find((elem, key) => {
          return elem.is_default === 1;
        });
        this.form_data.address_id = default_address ? default_address.id : 0;
      })
    );
    this.getCountryList();
  },
  methods: {
    async getCountryList() {
      GetRegionList().then((res) => {
        this.countryList = res.data;
      });
    },
    async getStateList() {
      let country = this.countryList.find(
        (i) => i.name == this.form_data_address.country
      );
      if (!country) {
        return;
      }
      GetRegionList({
        parent_id: country.country_id,
        type: 1,
      }).then((res) => {
        this.stateList = res.data;
      });
    },
    close() {
      this.form_data_address = { ...form_data_address };
      this.value = [];
    },
    save(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          SaveAddress(this.form_data_address)
            .then(() => {
              this.$layer.msg(`Saved successfully`);
              this.form_data_address = { ...form_data_address };
              this.value = [];
              this.is_popup_show = false;
              return this.getAddressList();
            })
            .then(() => {
              this.change_address(this.address_list[0]);
            })
            .finally(() => {});
        }
      });
    },
    add_address() {
      this.is_popup_show = true;
    },
    edit_address(id) {
      GetAddress({ id }).then((response) => {
        this.form_data_address = response.data;
        this.value = [
          this.form_data_address.province,
          this.form_data_address.city,
          this.form_data_address.zone,
        ];
        this.is_popup_show = true;
      });
    },
    change_payment(e) {
      this.pay_type = e;
    },
    async checkout() {
      if (this.is_click) {
        return;
      }
      if (this.form_data.address_id === 0) {
        this.$layer.msg(`Please select a shipping address`);
        return;
      }
      if (!this.pay_type) {
        this.$layer.msg(`Please select a payment method`);
        return;
      }

      this.is_click = true;
      CheckoutOrder(this.form_data)
        .then(() => {
          this.$layer.msg(`Order confirmed, redirecting to payment...`);
          setTimeout(() => {
            this.$router.replace({
              name: "CashDesk",
              query: { uuid: this.form_data.uuid, pay_type: this.pay_type },
            });
          }, 1500);
        })
        .catch((e) => {
          this.$layer.msg(e.msg);
        })
        .finally(() => {
          this.is_click = false;
        });
    },
    go2address() {
      this.$router.push({ name: "Address" });
    },
    change_address(v) {
      this.form_data.address_id = v.id;
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getAddressList() {
      return AddressList().then((response) => {
        this.address_list = response.data;
        return response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1279px;
  max-width: 1920px;
  background: #f6f7fa;
  .main-container {
    width: 100%;
    max-width: 1516px;
    display: flex;
    justify-content: center;
    column-gap: 16px;
    .left-box {
      //   width: 100%;
      //   max-width: 1140px;
      flex: 3;
      min-width: 700px;
      display: flex;
      flex-direction: column;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.address-panel {
          max-width: 1140px;
          .title {
            display: flex;
            justify-content: space-between;
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            .btn-address {
              color: #fa3d5a;
              font-size: 12px;
              font-weight: normal;
              cursor: pointer;
              margin: 0 10px;
            }
          }
          .address-list {
            display: flex;
            flex-wrap: wrap;
            .address-item {
              position: relative;
              margin: 10px 5px;
              width: 49%;
              height: 100px;
              padding: 10px 10px 10px 45px;
              color: #191a1c;
              border: 1px solid #e3e3e3;
              border-radius: 6px;
              cursor: pointer;
              .location {
                position: absolute;
                top: 16px;
                left: 16px;
                width: 20px;
                height: 24px;
              }
              .content1 {
                width: 320px;
                font-size: 12px;
                margin: 5px 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                span {
                  margin: 0 3px;
                }
              }
              .content2 {
                width: 320px;
                font-size: 13px;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .contact {
                width: 200px;
                margin-top: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .btn-edit {
                position: absolute;
                right: 10px;
                bottom: 5px;
                font-size: 12px;
              }
              &.active {
                border: 1px solid #fa3d5a;
              }
            }
          }
        }

        &.product-panel {
          max-width: 1140px;
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            table-layout: fixed;
            border: 1px solid #e5e5e5;
            thead {
              background: #f6f7fa;
              line-height: 52px;
              color: #575859;
              font-size: 14px;
              text-align: center;
            }
            th {
              border: none;
            }
            th,
            td {
              text-align: center;
              width: 190px;
              &:first-child {
                width: auto;
                min-width: 300px;
                max-width: 480px;
              }
            }
            tbody {
              tr {
                td {
                  .info {
                    position: relative;
                    width: 480px;
                    height: 110px;
                    // border-right: 1px solid #e3e3e3;
                    .image {
                      position: absolute;
                      top: 20px;
                      left: 20px;
                      width: 68px;
                      height: 68px;
                      object-fit: cover;
                    }
                    .name {
                      position: absolute;
                      top: 34px;
                      left: 150px;
                      color: #191a1c;
                      font-size: 14px;
                      font-weight: 500;
                    }
                    .category {
                      position: absolute;
                      top: 66px;
                      left: 150px;
                    }
                  }
                }
              }
            }
          }
          .th {
            display: flex;
            flex-wrap: nowrap;
            line-height: 52px;
            text-align: center;
            background: #f6f7fa;
            border-radius: 5px 5px 0px 0px;
            border: 1px solid #e3e3e3;
            color: #575859;
            font-size: 14px;
            .info {
              width: 480px;
            }
            .size {
              width: 190px;
            }
            .quantity {
              width: 190px;
            }
            .price {
              width: 190px;
            }
          }
          .td {
            display: flex;
            flex-wrap: nowrap;
            text-align: center;
            border: 1px solid #e3e3e3;
            .info {
              position: relative;
              width: 480px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
              .image {
                position: absolute;
                top: 20px;
                left: 20px;
                width: 68px;
                height: 68px;
                object-fit: cover;
              }
              .name {
                position: absolute;
                top: 34px;
                left: 150px;
                color: #191a1c;
                font-size: 14px;
                font-weight: 500;
              }
              .category {
                position: absolute;
                top: 66px;
                left: 150px;
              }
            }
            .size {
              padding: 0 5px;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              align-content: center;
              justify-content: center;
              width: 190px;
              height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .quantity {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
            }
            .price {
              width: 190px;
              height: 110px;
              line-height: 110px;
              border-right: 1px solid #e3e3e3;
              font-weight: bold;
              font-size: 14px;
            }
          }
        }

        &.summary-panel {
          max-width: 1140px;
          .wrap {
            background: #f6f7fa;
            display: flex;
            flex-wrap: nowrap;
            .left {
              width: 550px;
              border: 1px solid #e3e3e3;
              padding: 0 20px;
              .item {
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0;
                height: 55px;
                font-size: 12px;
                border-bottom: 1px solid #e3e3e3;
                .label {
                  width: 100px;
                  color: #191a1c;
                  font-weight: bold;
                }
                .text {
                  color: #7e7f80;
                  input {
                    border: none;
                    outline: none;
                  }
                }
              }
            }
            .right {
              padding: 0 20px;
              .title {
                font-size: 15px;
                height: 55px;
                line-height: 55px;
                margin: 10px 0;
                font-weight: bold;
              }
              textarea {
                width: 550px;
                height: 350px;
                outline: none;
                padding: 10px;
                border: none;
                background: white;
              }
            }
          }
        }
      }
    }
    .right-box {
      //   width: 360px;
      flex: 1;
      min-width: 100px;
      max-width: 360px;
      .panel {
        margin: 20px 0;
        padding: 30px 20px;
        background: white;
        border-radius: 10px;
        &.operation-panel {
          // position: absolute;
          // top: 105px;
          // right: 180px;
          //   width: 360px;
          width: 100%;
          // height: 550px;
          .order-img {
            margin-top: 25px;
            width: 68px;
            height: 68px;
            object-fit: cover;
            object-position: center;
          }
          .item {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            margin: 10px 0;
            height: 30px;
            font-size: 12px;
            .label {
              width: 100px;
              color: #575859;
            }
            .text {
              font-weight: bold;
              color: #333333;
            }
          }
          .separator {
            height: 2px;
            background: #e3e3e3;
          }

          .pay-list {
            padding: 25px;
            background: #f3f6f8;
            border-radius: 10px;
            .pay-item {
              display: flex;
              flex-wrap: nowrap;
              align-items: center;
              margin: 8px 0;
              color: #11192d;
              font-size: 14px;
              input {
                margin-right: 10px;
              }
              .icon {
                width: 20px;
                height: 20px;
              }
              span {
                margin-left: 10px;
              }
            }
          }

          .btn-checkout {
            cursor: pointer;
            //   position: absolute;
            // width: 320px;
            //   bottom: 40px;
            width: 100%;
            margin-top: 50px;
            height: 42px;
            line-height: 42px;
            color: white;
            background: #fa3d5a;
            text-align: center;
            font-size: 14px;
            border-radius: 10px;
          }
        }
      }
    }
  }
}

::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

::v-deep .ivu-input {
  height: 40px;
  line-height: 40px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding: 0 10px;
  outline: none;
}
::v-deep .ivu-select-selection {
  height: 40px;
  line-height: 40px;
}
::v-deep .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 40px;
  line-height: 40px;
}
::v-deep .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 40px;
  line-height: 40px;
}
.add-address-box {
  height: 40px;
  background: #ffffff;
  border-radius: 2px 2px 2px 2px;
  border: 1px solid #999999;
  padding: 0 16px;
  cursor: pointer;

  img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
}
.empty-address {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 130px;
  .tip1 {
    font-size: 22px;
    color: #212121;
  }
  .tip2 {
    font-size: 14px;
    color: #212121;
  }
  .empty-icon {
    width: 57px;
    height: 57px;
  }
}
.address-form {
  padding: 30px 20px;
  .form-group {
    margin-bottom: 20px;
    ::v-deep .ivu-form-item-label {
      font-size: 14px;
      color: #212121;
      padding: 0px;
      margin-bottom: 5px;
    }
    ::v-deep .ivu-input {
      border-radius: 2px;
    }
    .input {
      //   width: 100%;
      //   height: 40px;
      //   line-height: 40px;
      //   padding: 0 10px;
      //   outline: none;
      //   background: #ffffff;
      border-radius: 2px;
      //   border: 1px solid #cbcbcb;
    }
  }
  .btn-submit {
    width: 220px;
    height: 40px;
    background: #0d0c22;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
  }
}

.address-box {
  width: 49%;
  background: #fafafa;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  .icon-location {
    width: 26px;
    height: 26px;
  }
  .top-box {
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
    .address-content {
      font-size: 14px;
      color: #000000;
      line-height: 24px;

    }
  }
  .bottom-box {
    padding: 16px 20px;
    font-size: 14px;
    color: #4d4d4d;
    cursor: pointer;
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
}
</style>
